var createGroupedArray = function(arr, chunkSize) {
  var groups = [], i;
  for (i = 0; i < arr.length; i += chunkSize) {
    groups.push(arr.slice(i, i + chunkSize));
  }
  return groups;
}

export default createGroupedArray;



// WEBPACK FOOTER //
// ./src/util/createGroupedArray/index.js